export enum NotifyErrorDescription {
  UnexpectedError = "An unexpected error occurred",
  UnexpectedErrorPleaseRefresh = "An unexpected error occurred, please refresh and try again",
  UnexpectedErrorTryAgainLater = "An unexpected error occurred. Please try again later",
  UnexpectedLogoutError = "An unexpected error occurred while logging out, please refresh and try again",
}
